const BASE = 16;
const MOBILE_MIN_WIDTH = 768;

/**
 * Transforms the given font size stored for form styling into a CSS unit.
 *
 * @param {number} fontSize
 * @return {string}
 */
export default (fontSize) => {
    if (fontSize < BASE && window.screen.width && window.screen.width <= MOBILE_MIN_WIDTH) {
        return `${BASE}px`;
    }

    return fontSize != null ? `${Math.round((fontSize / BASE) * 100) / 100}rem` : fontSize;
};
